import { API_URL } from '../../../app-config/constants';
import type { CoachResource } from '../../react/features/AiCoach/types';
import { get, post, put, remove } from '../request';

const BASE_URL = `${API_URL}/copilot-resources`;

getResources.operation = 'READ';
export function getResources() {
    return get<CoachResource[]>(`${BASE_URL}`);
}

createResource.operation = 'CREATE';
export function createResource(resource: Omit<CoachResource, 'id' | 'attachmentId'>) {
    return post<CoachResource>(`${BASE_URL}`, { postData: resource });
}

updateResource.operation = 'UPDATE';
export function updateResource(resource: CoachResource) {
    return put<CoachResource>(`${BASE_URL}/${resource.id}`, { postData: resource });
}

deleteResource.operation = 'DELETE';
export function deleteResource(id: string) {
    return remove(`${BASE_URL}/${id}`);
}
